// Standard request/response calls go through API Gateway (TLS termination,
// auth, throttling, etc). Use this for everything except long-lived streams.
export const BASE_URL = 'https://seawatch-api.space-eyes.com';

// Server-Sent Events (and any other long-lived streaming responses) go DIRECT
// to the OneAPI ALB via this dedicated subdomain, bypassing API Gateway.
// Reason: AWS API Gateway REST APIs buffer the entire response body before
// forwarding any bytes downstream and enforce a hard 29-second integration
// timeout, which makes them fundamentally incompatible with SSE. The ALB
// streams natively. Use this constant for EventSource construction only.
export const SSE_BASE_URL = 'https://seawatch-sse.space-eyes.com';

export async function fetchClient<T>(
  endpoint: string,
  options: RequestInit = {},
  getToken: () => Promise<string>,
): Promise<T> {
  const token = await getToken();

  const response = await fetch(`${BASE_URL}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`Request failed: ${response.status} ${response.statusText}`);
  }

  return response.json();
}

/**
 * Fetch client for unauthenticated requests (e.g. checkout, register before login)
 */
export async function fetchClientPublic<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(`${BASE_URL}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`Request failed: ${response.status} ${response.statusText}`);
  }

  return response.json();
}
